<template>
    <div id="contactoScroll">
        <div class="container">
            <div class="row align-items-center justify-content-center">
            <div class="col-md-7 text-center" data-aos="fade">
                <span class="caption mb-3 sub-heading">{{$t('Contacto["Comentario"]')}}</span>
                <h1 class="mb-4 sub-heading">{{$t('Contacto["Titulo"]')}}</h1>
            </div>
            </div>
        </div>
        <div class="site-section site-section-sm">
            <div class="container">
            <div class="row">
                <div class="col-md-12 col-lg-8 mb-5">
                <form action="#" class="p-5 bg-white">
                    <div class="row form-group">
                    <div class="col-md-12 mb-3 mb-md-0">
                        <label class="font-weight-bold" for="fullname">{{$t('Contacto["Labels"]["Nombre"]')}}</label>
                        <input v-model="name" type="text" id="fullname" class="form-control" :placeholder="$t('Contacto.Placeholders.Nombre')">
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="email">{{$t('Contacto["Labels"]["Correo"]')}}</label>
                        <input v-model="email" type="email" id="email" class="form-control" :placeholder="$t('Contacto.Placeholders.Correo')">
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12 mb-3 mb-md-0">
                        <label class="font-weight-bold" for="phone">{{$t('Contacto["Labels"]["Telefono"]')}}</label>
                        <input v-model="phone" type="text" id="phone" class="form-control" :placeholder="$t('Contacto.Placeholders.Telefono')">
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="message">{{$t('Contacto["Labels"]["Mensaje"]')}}</label>
                        <textarea v-model="problem" name="message" id="message" cols="30" rows="5" class="form-control" :placeholder="$t('Contacto.Placeholders.Mensaje')"></textarea>
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                        <input @click="SendMail()" :Value="$t('Contacto.Labels.Enviar')" class="btn btn-primary pill px-4 py-2">
                    </div>
                    </div>
                </form>
                </div>
                <div class="col-lg-4">
                <div class="p-4 mb-3 bg-white">
                    <h3 class="h5 text-black mb-3">{{$t('Contacto["Informacion"]["Titulo"]')}}</h3>
                    <p class="mb-0 font-weight-bold">{{$t('Contacto["Informacion"]["Direccion"]')}}</p>
                    <p v-if="hotelData" class="mb-4">{{hotelData.direccion}} </p>
                    <p class="mb-0 font-weight-bold">{{$t('Contacto["Informacion"]["Telefono"]')}}</p>
                    <p v-if="hotelData" class="mb-4">{{hotelData.phone}}</p>
                    <p class="mb-0 font-weight-bold">{{$t('Contacto["Informacion"]["Correo"]')}}</p>
                    <p v-if="hotelData" class="mb-0">{{hotelData.email}}</p>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import mailCliente from './../MailTemplates/MailEmpresa.vue'
import mailHotel from './../MailTemplates/MailEmpresaHotel.vue'
export default {
    name: "Contactanos",
    data () {
      return {
        name: null,
        phone: null,
        email: null,
        problem: null,
        message:null,
      }        
    },
    props: {
        hotelData: {
            required: true
        }        
    },
    methods: {        
        async SendMail () {  
            this.$message({
                message: 'Su mensaje esta siendo enviado, porfavor espere, gracias.',
                type: 'info'
            });
            if(isNaN(this.phone) && this.phone === null)
            {
                this.message = "Estimado, el número de teléfono debe contener solo números"
                this.failure()
                return
            }
            if( this.name === null)
            {
                this.message = "Porfavor necesitamos que nos diga su nombre para saber como llamarlo"
                this.failure()
                return
            }
            if( this.email === null || !this.validateEmail(this.email))
            {
                this.message = "Tiene que dejar su correo para poder comunicarnos con usted"
                this.failure()
                return
            }
            if( this.problem === null)
            {
                this.message = "Debe comunicarnos que desea saber"
                this.failure()
                return
            }

            const msjCliente = new Vue({
                render: h => h(mailCliente, {
                    props: {
                        name: this.name,
                        problem: this.problem,
                        email: this.email,
                        empresa: this.hotelData.name,
                        phone: this.phone,
                        correo: this.hotelData.email
                    }
                })
            })

            const htmlCliente = msjCliente.$mount().$el.outerHTML

            const msjHotel = new Vue({
                render: h => h(mailHotel, {
                    props: {
                        name: this.name,
                        problem: this.problem,
                        email: this.email,
                        empresa: this.hotelData.name,
                        phone: this.phone,
                        correo: this.hotelData.email
                    }
                })
            })

            const htmlHotel = msjHotel.$mount().$el.outerHTML

            let url = 'https://ctws.azurewebsites.net/MailApi/SendEmail/?x=Nno2ufull9A2O8hO8jEEijE2PgrsB79Wzybiaysq0sOW+9TEtsf1gVigYt59z363ArlqzybbPLRNci9NHHYFBbU2SHL6oxmf5tDYcuWxVwGo1rqAclluxoYpCpzWI4EeDLCtoqJPsLMZe0K81uK+H2bBTygUlWAmkw04xVF+yVbp93b4h6vC3I/7GXPqjUD+yX2mWfPwms72J85WU2Q5IfoAeNp5V26KAukPUS5iFnM8D2qCzL+nBLVGDoU81PRUNCspnKeyf4RkdkBxxKBpEfDTcTwDmw9cnC8UTVv4n22er/rWbPQDdsoqpEukRlm8L+Iu5Ug0Rl+/QmJvyG1GqOYcdXVqsBKmW3tKm3AaYvZo1jfAZBQGy7BjDG3uyAku';


            const jsonSendCliente = {
                "emailTo":[               
                  this.email
                ],
                "emailFrom" :  'notificaciones@chevere.tech',
                "subject" : "Confirmación de consultas",
                "body" :  btoa(htmlCliente),
                "attachments" : null
            }            

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : jsonSendCliente
            };

            const jsonSendHotel = {
                "emailTo":[               
                  this.hotel.email
                ],
                "emailFrom" :  'notificaciones@chevere.tech',
                "subject" : "Confirmación de consultas",
                "body" :  btoa(htmlHotel),
                "attachments" : null
            }            

            let configHotel = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : jsonSendHotel
            };

            axios.request(config)
            .then((response) => {
              axios.request(configHotel)
              .then((response) => {
                  this.success(); 
              })
            })
            .catch((error) => {
                this.failure();    
            });           
        },
        failure() {            
            this.$message.error(this.message);
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            return re.test(email);
        },
        success() {
            this.$message({
            message: 'Su mensaje ha sido enviado, nos pondremos en contacto con usted lo más pronto posible, gracias.',
            type: 'success'
            });
            this.name= null;
            this.phone= null;
            this.email= null;
            this.problem= null;
        }
    }
}
</script>

<style scoped>
    #contactoScroll{
        padding-top: 100px;
    }
    .sub-heading{
      color: black !important;
    }
</style>


// WEBPACK FOOTER //
// Contactanos.vue?d51dce16